import ApiService from "../api";

export default class FuncionarioService extends ApiService {

    constructor() {
        super('/api/funcionarios')
    }

    listar(data) {
        const params = new URLSearchParams();
        if (data?.id) params.append('id', data.id);
        if (data?.nome) params.append('nome', data.nome);
        if (data?.cargo) params.append('cargo', data.cargo);
        if (data?.filialId) params.append('filialId', data.filialId);
        if (data?.codigoFortes) params.append('codigoFortes', data.codigoFortes);

        return this.get(`/v1?${params}`);
    }

    listaFuncionarios(values) {
        const {
            filiais = [],
            nomes = [],
            status = [],
            cargos = [],
            codigos = [],
            somenteComPonto = null,
        } = values;

        const params = new URLSearchParams();

        if (filiais.length) params.append("filiais", filiais.join(","));
        if (nomes.length) params.append("nomes", nomes.join(","));
        if (status.length) params.append("status", status.join(","));
        if (cargos.length) params.append("cargos", cargos.join(","));
        if (codigos.length) params.append("codigos", codigos.join(","));
        if (somenteComPonto === true) params.append("somenteComPonto", true)

        return this.get(`?${params}`);
    }

    listarAuxiliaresDeCarga(filialId) {
        const params = new URLSearchParams();
        if (filialId) params.append('filialId', filialId);

        return this.get(`/auxiliares-de-carga?${params}`);
    }

    listarCargos() {
        return this.get(`/cargos/listar-todos`);
    }

    listarMotoristas(filialId) {
        const params = new URLSearchParams();
        if (filialId) params.append('filialId', filialId);
        return this.get(`/motoristas?${params}`);
    }

    listarAfastamentos(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);
        params.append('tipoDistribuidor', values.tipoDistribuidor);

        if (values.funcionarioId) params.append('funcionarioId', values.funcionarioCodigo);

        return this.get(`/buscar-afastamentos?${params.toString()}`)
    }

    listarCargos() {
        return this.get(`/cargos`);
    }

    buscarPorCodigo(codigo) {
        return this.get(`/${codigo}`);
    }

    sincronizarTrixlog() {
        return this.put(`/sincronizar-trixlog`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(dto) {
        return this.put(``, dto);
    }

    excluir(codigo) {
        return this.delete(`/${codigo}`);
    }
}